var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bet-type"},[_c('div',{class:[
      'type',
      _vm.getBet.type == 'single' || _vm.getBet.type == 'multiple' ? 'active' : '',
      _vm.getBet.type == 'integral' ? 'disabled' : ''
    ],on:{"click":function($event){return _vm.changeTypeCart('multiple')}}},[(_vm.getBet.type == 'single' && _vm.getSettings.single)?_c('span',[_vm._v(_vm._s(_vm.$t('single')))]):_c('span',[_vm._v(_vm._s(_vm.$t('multiple')))])]),(_vm.getSettings.integral)?_c('div',{class:['type', _vm.getBet.type == 'integral' ? 'active' : 'disabled']},[_c('span',[_vm._v(_vm._s(_vm.$t('integral')))])]):_vm._e(),(_vm.getSettings.system)?_c('div',{class:[
      'type',
      _vm.getBet.type == 'system' ? 'active' : '',
      _vm.getBet.type == 'integral' ||
      _vm.getBet.type == 'single' ||
      _vm.getBet.odds.length == 1 ||
      _vm.getBet.odds.length > 10
        ? 'disabled'
        : ''
    ],on:{"click":function($event){return _vm.changeTypeCart('system')}}},[_c('span',[_vm._v(_vm._s(_vm.$t('system')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }